import React from 'react';
import Dialog from 'components/pure/utils/Dialog';
import Button from '@material-ui/core/Button';
import Loading from 'components/pure/utils/Loading';
import DirectCallSharingDialogContainer from 'components/stateful/sharing/DirectCallSharingDialogContainer';
import './CallSharingDialog.styl';
import {Checkbox} from 'material-ui';

export default class CallSharingDialog extends React.Component {
  constructor(props) {
    super(props);

    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);

    // Note: this component gets passed onSubmit/isDisabled from its children.
    // This is due to the fact that our Dialog knows about the submit/cancel buttons,
    // But the children handle what happens when they're selected.  The children
    // have an `onLoad` that is meant to wire these up when they become visible.
    this.state = {
      onSubmit: () => null,
      isDisabled: () => false,
      slackNotify: false,
      submitted: false,
    };
  }

  onClose() {
    this.props.onClose();
  }

  onSubmit() {
    this.setState({submitted: true});
    this.state.onSubmit();
  }

  render() {
    const {hasSlack, hasSlackLoaded, targetsMightHaveSlack} = this.props;

    const isDisabled = this.state.isDisabled();
    const onLoad = (onSubmit, isDisabled) =>
      this.setState({
        onSubmit,
        isDisabled,
      });

    const showSlackCheckbox = hasSlack && hasSlackLoaded && targetsMightHaveSlack;

    return (
      <Dialog
        className="share-call-dialog"
        modal={true}
        open={!!this.props.open}
        showTitleBar={true}
        title={'Share Call'}
        autoScrollBodyContent={false}
        onRequestClose={this.onClose}
        actions={[
          showSlackCheckbox && (
            <Checkbox
              className="slack-checkbox"
              label="Notify By Slack"
              onCheck={() => this.setState({slackNotify: !this.state.slackNotify})}
              checked={this.state.slackNotify}
              key="1"
            />
          ),
          <Button variant="outlined" className="ev-button" key="2" onClick={this.onClose}>
            Cancel
          </Button>,
          <Button
            variant="contained"
            color="primary"
            className="ev-button"
            key="3"
            onClick={this.onSubmit}
            primary={true}
            disabled={isDisabled}>
            Share
          </Button>,
        ]}>
        {!this.props.fileUpload ? (
          <Loading />
        ) : (
          <DirectCallSharingDialogContainer
            {...this.props}
            submitted={this.state.submitted}
            slackNotify={this.state.slackNotify}
            visible={true}
            onLoad={onLoad}
          />
        )}
      </Dialog>
    );
  }
}
